
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://intqojhpldgpqffwvuep.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImludHFvamhwbGRncHFmZnd2dWVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUzMTU0NTYsImV4cCI6MjA1MDg5MTQ1Nn0.lRak6og1_okKAcpo4YHAjzJnzwVjsDRVQWY82cgtNEs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
